<template>
  <div class="qrcode">
    <img :src="currentImg" :alt="$t('nav.guide')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentImg: require("@/assets/daolan.jpg"),
    }
  },
}
</script>

<style lang="less" scoped>
.qrcode {
  width: 100%;
  margin-top: 4.53vw; /* 87px at 1920px */
  img {
    width: 100%;
    padding: 0;
  }
}
</style>
